<template>
    <div class="header-bar">
        <button class="toggle-mobile-menu" @click="toggleSidebar()">
            <i class="icon icon-dashes"></i>
        </button>

        <h3>{{ $t(currentRouteName) }}</h3>

        <button class="toggle-reminders" @click="toggleReminders()">
            <i class="icon icon-bell"></i>
        </button>
    </div>
</template>

<script>
import { EventBus } from '../../../event-bus';

export default {
    name: "HeaderBar",

    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    },

    methods: {
        toggleSidebar() {
            EventBus.$emit('toggle-sidebar');
        },

        toggleReminders() {
            EventBus.$emit('open-side-form', 'reminders')
        },
    }
}
</script>

<style scoped lang="scss">
.header-bar {
    @media (min-width: 768px) {
        display: none;
    }

    position: fixed;
    top: 0;
    left: 0;
    width: calc(100% - 48px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 50;
    height: 24px;
    background: rgba(#fff, .5);
    padding: 24px;
    backdrop-filter: blur(30px);

    h3 {
        font-size: 18px;
        font-family: "Proxima Nova Lt";
        font-weight: 600;
        color: #152640;
        margin: 0;
    }

    button {
        border: 0;
        outline: 0;
        background: none;
    }
}
</style>